import { combineReducers } from "redux";
import documentDecisionReducer from "./edit/decision/documentDecisionReducer";
import { scoringReducer } from "./edit/scoring/reducer";
import scoringHistoryReducer from "./edit/scoringHistory/reducer";
import documentWarrantyDataReducer from "./edit/financials/warranty/reducer";
import documentExposureReducer from "./edit/exposure/reducer";
import documentVerificationsReducer from "./edit/verification/reducer";
import checkListReducer from "./edit/checklist/reducer";
import { stateTransitionsReducer } from "./edit/stateTransitions/reducer";
import documentPropertiesReducer from "./edit/documentProperties/reducer";
import { documentsReducer } from "features/document/edit/documents/reducer";
import contractGenerationReducer from "./edit/contractGeneration/reducer";
import leasingContractsReducer from "../offer/edit/contract/reducer";
import documentEntitiesReducer from "features/document/edit/verification/documentEntitiesReducer";
import guarantorsReducer from "./edit/financials/guarantorsReducer";

const documentReducer = combineReducers({
  decision: documentDecisionReducer,
  scoringData: scoringReducer,
  scoringHistoryData: scoringHistoryReducer,
  warrantyData: documentWarrantyDataReducer,
  guarantors: guarantorsReducer,
  exposure: documentExposureReducer,
  checklist: checkListReducer,
  stateTransitions: stateTransitionsReducer,
  documents: documentsReducer,
  entities: documentEntitiesReducer,
  documentProperties: documentPropertiesReducer,
  contractGeneration: contractGenerationReducer,
  leasingContracts: leasingContractsReducer,
  verifications: documentVerificationsReducer
});

export default documentReducer;
